import * as angular from 'angular'
import { RegistersResource } from './registers-resource.service'

angular
  .module('webregister.services')
  .service('registersResource', RegistersResource)
